import { HttpError } from "../../shared/types/exception";

export function getExceptionStatusAndMessage(exception: unknown) {
  let status = 0;
  let message = "";

  if (exception instanceof HttpError) {
    status = exception.status;
    message = exception.statusText;
  }
  if (exception instanceof Error) {
    message = exception.message;
  }

  return { status, message };
}
